import React, { useEffect, useState, useCallback } from 'react';
import { Star } from 'lucide-react';
import surveysApi from '../services/surveysApi.js';
import SurveyResponsesModal from './SurveyResponsesModal.jsx';

const POLL_INTERVAL_MS = 60_000;

const SurveyRatingChip = () => {
  const [summary, setSummary] = useState({ avg_rating: null, total: 0 });
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const data = await surveysApi.summary();
      setSummary({
        avg_rating: data?.avg_rating ?? null,
        total: Number(data?.total || 0),
      });
      setError(false);
    } catch {
      setError(true);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [refresh]);

  const handleClose = useCallback(() => {
    setOpen(false);
    refresh();
  }, [refresh]);

  if (error && summary.total === 0) {
    return null;
  }

  const avgLabel = summary.avg_rating != null ? Number(summary.avg_rating).toFixed(2) : '—';

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Опросник удовлетворённости"
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-yellow-50 dark:bg-yellow-900/20 text-yellow-700 dark:text-yellow-300 hover:bg-yellow-100 dark:hover:bg-yellow-900/30 transition-colors border border-yellow-200/60 dark:border-yellow-700/40"
      >
        <Star size={16} className="fill-yellow-400 text-yellow-400" />
        <span className="text-sm font-medium tabular-nums">{avgLabel}</span>
        <span className="text-xs text-yellow-600/80 dark:text-yellow-400/80">·</span>
        <span className="text-xs tabular-nums">{summary.total}</span>
      </button>
      <SurveyResponsesModal open={open} onClose={handleClose} />
    </>
  );
};

export default SurveyRatingChip;
